import { useRef, useState, useEffect } from "react";
import Navbar from "../layout/Navbar";
import Footer from "../layout/Footer";
import about_agency from "../assests/Images/About_agency.jpg";
import arunSir_image from "../assests/Images/ArunMisra_image-PPT.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import brochure from "../assests/PDF/People-process-teck-E-Brochure.pdf";
import business_growth from "../assests/Images/Business_growth.jpg";
import register_icon from "../assests/Images/registration icon.png";
import time_icon from "../assests/Images/time_icon.png";
import bulb_icon from "../assests/Images/bulb_icon.png";
import hiring_icon from "../assests/Images/hiring_icon.png";
import { GiFlatStar } from "react-icons/gi";
import "swiper/css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import useIsMobile from "../core/hooks/isMobile";
import { MdManageAccounts } from "react-icons/md";
import { HiCurrencyDollar } from "react-icons/hi2";
import { Link, NavLink } from "react-router-dom";
import { FaTrophy } from "react-icons/fa";
import { GoLaw } from "react-icons/go";
import { GrUserWorker } from "react-icons/gr";
import { useInView } from "react-intersection-observer";
import case_studies1 from "../assests/Images/CaseStudies_01.jpg";
import case_studies2 from "../assests/Images/CaseStudies_02.jpg";
import case_studies3 from "../assests/Images/CaseStudies_03.jpg";
import case_studies4 from "../assests/Images/CaseStudies_04.jpg";
import case_studies5 from "../assests/Images/CaseStudies_05.jpg";
import home1 from "../assests/new/sliderOne.png";
import home6 from "../assests/Images/Home1.jpg";
import home3 from "../assests/Images/Home3.jpg";
import home5 from "../assests/Images/Home5.jpg";
import { FaUsers, FaDownload } from "react-icons/fa";
import IndigisBrochure from "../assests/PDF/INDIGIS Enterprise.pdf";

import clientOne from "../assests/Images/cilents/ADITYA.png";
import clientTwo from "../assests/Images/cilents/CASA.png";
import clientThree from "../assests/Images/cilents/FUTURZ.png";
import clientFour from "../assests/Images/cilents/IPSTAR.jpg";
import clientFive from "../assests/Images/cilents/Kempegowda.png";
import clientSix from "../assests/Images/cilents/Logo-PPT-2.png";
import clientSeven from "../assests/Images/cilents/MAYFAIR.png";
import clientEigth from "../assests/Images/cilents/MORPH.png";
import clientNine from "../assests/Images/cilents/MRF.png";
import clientTen from "../assests/Images/cilents/NTPC.png";
import clientEleven from "../assests/Images/cilents/ONE-LIFE.png";
import clientTwelve from "../assests/Images/cilents/ORSAC.png";
import clientThirteen from "../assests/Images/cilents/RHI-MAGNESTIA.png";
import clientFourteen from "../assests/Images/cilents/TATA-ADVANCE.png";
import clientFifthteen from "../assests/Images/cilents/TATA-POWER-SOLAR.png";
import clientSixteen from "../assests/Images/cilents/TVS.png";
import clientSeveteen from "../assests/Images/cilents/Vidiem.png";
import clientEighteen from "../assests/Images/cilents/century-ply.png";
import clientNineteen from "../assests/Images/cilents/emerald.png";
import clientTwenty from "../assests/Images/cilents/hutchinson.png";
import clientTwentyOne from "../assests/Images/cilents/logo-PPT.png";
import clientTwentyTwo from "../assests/Images/cilents/novac.png";
import clientTwentyThree from "../assests/Images/cilents/oasys.png";
import clientTwentyFour from "../assests/Images/cilents/wheels-india-limited.png";
import clientTwentyFive from "../assests/Images/cilents/yanmar.png";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

const Counter = ({ targetNumber }) => {
  const [count, setCount] = useState(0);
  const ref = useRef();
  const hasAnimated = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated.current) {
          let start = 0;
          const duration = 1000;
          const stepTime = Math.abs(Math.floor(duration / targetNumber));

          const timer = setInterval(() => {
            start += 1;
            setCount(start);
            if (start >= targetNumber) {
              clearInterval(timer);
              hasAnimated.current = true;
            }
          }, stepTime);
        }
      },
      { threshold: 0.5 },
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, [targetNumber]);

  return (
    <h1 ref={ref} className="text-5xl font-bold text-primary">
      {count}+
    </h1>
  );
};

const Home = () => {
  const isMobile = useIsMobile();
  const swiperRef = useRef(null);

  const { ref: ref3, inView: inView3 } = useInView({
    triggerOnce: false,
    threshold: 0,
  });

  return (
    <>
      <Navbar />
      <div className="w-full max-h-screen bg-[#b22222] text-white relative overflow-hidden">
        <Swiper
          modules={[Pagination, Autoplay]}
          pagination={{ clickable: true }}
          autoplay={{ delay: 8000 }}
          loop
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          className="h-full w-full"
        >
          <div className="absolute top-10 left-10 w-24 h-24 bg-white/5 border border-white/10 rounded-lg backdrop-blur-sm rotate-12 z-0 float-box hidden md:block"></div>
          <div className="absolute top-1/2 left-20 w-16 h-16 bg-white/5 border border-white/10 rounded-lg rotate-[25deg] z-0 float-box hidden md:block"></div>

          <SwiperSlide>
            <div className="flex flex-col lg:flex-row items-center justify-between px-8 lg:px-24 py-16 min-h-[85vh] gap-12">
              <div className="w-full lg:w-1/2 flex justify-center order-2 lg:order-1">
                <div className="p-1 rounded-[2rem] outline outline-1 outline-white/20 bg-white/5 shadow-2xl">
                  <div className="rounded-[1.8rem] overflow-hidden border-4 border-white/90">
                    <img
                      src={home1}
                      alt="Geospatial"
                      className="object-cover w-[400px] h-[450px]"
                    />
                  </div>
                </div>
              </div>
              <div className="w-full lg:w-1/2 space-y-6 order-1 lg:order-2 text-center lg:text-left">
                <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight text-white">
                  Empowering India: Strategic Talent & Geospatial Intelligence
                </h1>
                <h2 className="text-xl md:text-2xl font-semibold text-white italic">
                  "Precision Technology, Empowered by Strategic Talent"
                </h2>
                <p className="text-lg md:text-xl text-gray-200 max-w-xl mx-auto lg:mx-0">
                  Official ToT Partner for DRDO’s INDIGIS Enterprise & Leaders
                  in HR Process Excellence.
                </p>
              </div>
            </div>
          </SwiperSlide>

          {/* Slide 2: Staffing (Updated for Consistency) */}
          <SwiperSlide>
            <div className="flex flex-col lg:flex-row items-center justify-between px-8 lg:px-24 py-16 min-h-[85vh] gap-12">
              <div className="w-full lg:w-1/2 flex justify-center order-2 lg:order-1">
                <div className="p-1 rounded-[2rem] outline outline-1 outline-white/20 bg-white/5 shadow-2xl">
                  <div className="rounded-[1.8rem] overflow-hidden border-4 border-white/90">
                    <img
                      src={home6}
                      alt="Staffing"
                      className="object-cover w-[400px] h-[450px]"
                    />
                  </div>
                </div>
              </div>
              <div className="w-full lg:w-1/2 space-y-6 order-1 lg:order-2 text-center lg:text-left">
                <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold leading-tight text-white">
                  Strategic Staffing Solutions
                </h1>
                <h2 className="text-xl md:text-2xl font-semibold text-white italic">
                  "Right Talent, Delivered on Demand"
                </h2>
                <p className="text-lg text-gray-200 max-w-xl mx-auto lg:mx-0">
                  Bridging the gap between specialized defense requirements and
                  world-class technical talent.
                </p>
              </div>
            </div>
          </SwiperSlide>

          {/* Slide 3: GRC */}
          <SwiperSlide>
            <div className="flex flex-col lg:flex-row items-center justify-between px-8 lg:px-24 py-16 min-h-[85vh] gap-12">
              <div className="w-full lg:w-1/2 flex justify-center order-2 lg:order-1">
                <div className="p-1 rounded-[2rem] outline outline-1 outline-white/20 bg-white/5 shadow-2xl">
                  <div className="rounded-[1.8rem] overflow-hidden border-4 border-white/90">
                    <img
                      src={home3}
                      alt="Compliance"
                      className="object-cover w-[400px] h-[450px]"
                    />
                  </div>
                </div>
              </div>
              <div className="w-full lg:w-1/2 space-y-6 order-1 lg:order-2 text-center lg:text-left">
                <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight text-white">
                  GRC@Pulse – Compliance Assurance
                </h1>
                <h2 className="text-xl md:text-2xl font-semibold text-white italic">
                  "Elevate Compliance from Obligation to Opportunity"
                </h2>
                <p className="text-lg text-gray-200 max-w-xl mx-auto lg:mx-0">
                  Reimagining Governance, Risk, and Compliance through
                  intelligent digital transformation.
                </p>
              </div>
            </div>
          </SwiperSlide>

          {/* Slide 4: Productivity */}
          <SwiperSlide>
            <div className="flex flex-col lg:flex-row items-center justify-between px-8 lg:px-24 py-16 min-h-[85vh] gap-12">
              <div className="w-full lg:w-1/2 flex justify-center order-2 lg:order-1">
                <div className="p-1 rounded-[2rem] outline outline-1 outline-white/20 bg-white/5 shadow-2xl">
                  <div className="rounded-[1.8rem] overflow-hidden border-4 border-white/90">
                    <img
                      src={home5}
                      alt="Productivity"
                      className="object-cover w-[400px] h-[450px]"
                    />
                  </div>
                </div>
              </div>
              <div className="w-full lg:w-1/2 space-y-6 order-1 lg:order-2 text-center lg:text-left">
                <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold leading-tight text-white">
                  Productivity Interventions
                </h1>
                <h2 className="text-xl md:text-2xl font-semibold text-white italic">
                  "Turning Efficiency into a Competitive Edge"
                </h2>
                <p className="text-lg text-gray-200 max-w-xl mx-auto lg:mx-0">
                  Optimizing operational workflows to drive measurable
                  performance and organizational growth.
                </p>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
        <button
          className="absolute left-6 top-1/2 -translate-y-1/2 z-50 bg-white/20 hover:bg-white/30 p-3 rounded-full transition"
          onClick={() => swiperRef.current.slidePrev()}
        >
          <svg
            className="w-6 h-6 text-white"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <path d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <button
          className="absolute right-6 top-1/2 -translate-y-1/2 z-50 bg-white/20 hover:bg-white/30 p-3 rounded-full transition"
          onClick={() => swiperRef.current.slideNext()}
        >
          <svg
            className="w-6 h-6 text-white"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <path d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
      <section className="py-10 bg-gray-100">
        <div className="flex justify-center"></div>
        
        <p className="text-sm sm:text-base lg:text-lg text-justify px-4 sm:px-6 lg:px-0 lg:mx-60 leading-7">
          At <b>People Process Teck,</b> we bridge the gap between human capital and advanced
           technology to drive measurable growth for your organization. Guided by our 
           philosophy of <b>"Strategic Excellence with a Human Touch,"</b> we deliver a unique
            spectrum of services that spans end-to-end HR solutions—including <b>Staffing 
            Solutions, Governance Risk and Compliance Assurance, Strategic HR interventions, 
            Productivity initiatives</b>—alongside cutting-edge geospatial intelligence.  
            <br /><br />
          <b>IndigisTechK</b> is our independent geospatial intelligence division that provides cutting-edge 
          Enterprise GIS solutions and remote sensing analytics. Whether optimizing your strategic
           workforce or solving complex spatial challenges, we empower businesses across India with
            targeted, data-driven solutions.  

        </p>
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={isMobile ? 0 : 30}
          slidesPerView={isMobile ? 1 : 3}
          navigation={false}
          loop={true}
          pagination
          autoplay={{
            delay: 8000,
            disableOnInteraction: false,
          }}
          className="mt-12 h-[20rem] !px-6 !pb-10"
        >
          <SwiperSlide>
            <div className="relative h-[20rem] bg-white rounded-md shadow-sm group overflow-hidden transition-shadow hover:shadow-xl p-6 hover:bg-primary/5 flex flex-col justify-between">
              <div className="absolute top-0 left-0 h-1 w-0 bg-gradient-to-r from-transparent via-red-700 to-transparent transition-all duration-500 group-hover:w-full"></div>
              <div>
                <div className="w-16 h-16 bg-blue-400 rounded-2xl flex items-center justify-center mb-4 transform transition-all duration-300 group-hover:scale-110 group-hover:rotate-3">
                  <MdManageAccounts className="text-white text-4xl" />
                </div>

                <h3 className="text-2xl font-bold text-gray-900 transition-colors duration-300 group-hover:text-primary">
                  Governance, Risk and Compliance
                </h3>

                <p className="text-gray-600 mt-2 line-clamp-3">
                  We link business strategy with robust governance, ensuring
                  statutory compliance and mitigating risks.
                </p>
              </div>

              <div className="opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300">
                <a
                  href="https://www.grcpulse.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300"
                >
                  <button className="text-lg text-gray-700 hover:text-white hover:bg-primary px-4 py-2 rounded-md transition-all duration-300">
                    Learn More →
                  </button>
                </a>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="relative h-[20rem] bg-white rounded-md shadow-sm group overflow-hidden transition-shadow hover:shadow-xl p-6 hover:bg-primary/5 flex flex-col justify-between">
              <div className="absolute top-0 left-0 h-1 w-0 bg-gradient-to-r from-transparent via-red-700 to-transparent transition-all duration-500 group-hover:w-full"></div>

              <div>
                <div className="w-16 h-16 bg-blue-400 rounded-2xl flex items-center justify-center mb-4 transform transition-all duration-300 group-hover:scale-110 group-hover:rotate-3">
                  <HiCurrencyDollar className="text-white text-4xl" />
                </div>

                <h3 className="text-2xl font-bold text-gray-900 transition-colors duration-300 group-hover:text-primary">
                  Total Staffing Solution
                </h3>

                <p className="text-gray-600 mt-2 ">
                  With four years of execution excellence in the industry,
                  People Process Teck has transformed the...
                </p>
              </div>

              <div className="opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300">
                <NavLink to="/staffing">
                  <button className="text-lg text-gray-700 hover:text-white hover:bg-primary px-4 py-2 rounded-md transition-all duration-300">
                    Learn More →
                  </button>
                </NavLink>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="relative h-[20rem] bg-white rounded-md shadow-sm group overflow-hidden transition-shadow hover:shadow-xl p-6 hover:bg-primary/5 flex flex-col justify-between bg-cover bg-center">
              <div className="absolute top-0 left-0 h-1 w-0 bg-gradient-to-r from-transparent via-red-700 to-transparent transition-all duration-500 group-hover:w-full"></div>
              <div>
                <div className="w-16 h-16 bg-blue-400 rounded-2xl flex items-center justify-center mb-4 transform transition-all duration-300 group-hover:scale-110 group-hover:rotate-3">
                  <FaTrophy className="text-white text-4xl" />
                </div>

                <h3 className="text-2xl font-bold text-gray-900 transition-colors duration-300 group-hover:text-primary">
                  Productivity Improvement Interventions
                </h3>

                <p className="text-gray-600 mt-2 ">
                  Through manpower optimization and process standardization, we
                  drive productivity enhancements. Lean manufacturing practices
                  and small ...
                </p>
              </div>

              <div className="opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300">
                <NavLink to="/productivity">
                  <button className="text-lg text-gray-700 hover:text-white hover:bg-primary px-4 py-2 rounded-md transition-all duration-300">
                    Learn More →
                  </button>
                </NavLink>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="relative h-[20rem] bg-white rounded-md shadow-sm group overflow-hidden transition-shadow hover:shadow-xl p-6 hover:bg-primary/5 flex flex-col justify-between bg-cover bg-center">
              <div className="absolute top-0 left-0 h-1 w-0 bg-gradient-to-r from-transparent via-red-700 to-transparent transition-all duration-500 group-hover:w-full"></div>
              <div>
                <div className="w-16 h-16 bg-blue-400 rounded-2xl flex items-center justify-center mb-4 transform transition-all duration-300 group-hover:scale-110 group-hover:rotate-3">
                  <GoLaw className="text-white text-4xl" />
                </div>

                <h3 className="text-2xl font-bold text-gray-900 transition-colors duration-300 group-hover:text-primary">
                  Strategic HR Business Partnership
                </h3>

                <p className="text-gray-600 mt-2 ">
                  Our approach is holistic. We optimize talent mapping, enhance
                  employee experience, and drive performance through ...
                </p>
              </div>

              <div className="opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300">
                <NavLink to="/stratrgic-HR">
                  <button className="text-lg text-gray-700 hover:text-white hover:bg-primary px-4 py-2 rounded-md transition-all duration-300">
                    Learn More →
                  </button>
                </NavLink>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="relative h-[20rem] bg-white rounded-md shadow-sm group overflow-hidden transition-shadow hover:shadow-xl p-6 hover:bg-primary/5 flex flex-col justify-between bg-cover bg-center">
              <div className="absolute top-0 left-0 h-1 w-0 bg-gradient-to-r from-transparent via-red-700 to-transparent transition-all duration-500 group-hover:w-full"></div>
              <div>
                <div className="w-16 h-16 bg-blue-400 rounded-2xl flex items-center justify-center mb-4 transform transition-all duration-300 group-hover:scale-110 group-hover:rotate-3">
                  <GrUserWorker className="text-white text-4xl" />
                </div>

                <h3 className="text-2xl font-bold text-gray-900 transition-colors duration-300 group-hover:text-primary">
                  Change Management Partnership
                </h3>

                <p className="text-gray-600 mt-2 ">
                  Through manpower optimization and process standardization, we
                  drive productivity enhancements. Lean manufacturing practices
                  and small ...
                </p>
              </div>

              <div className="opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300">
                <NavLink to="/productivity">
                  <button className="text-lg text-gray-700 hover:text-white hover:bg-primary px-4 py-2 rounded-md transition-all duration-300">
                    Learn More →
                  </button>
                </NavLink>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </section>

      <section>
        <div className="max-w-6xl mx-auto px-6 py-16 grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="relative rounded-2xl overflow-hidden shadow-xl">
              <img
                src={about_agency}
                alt=""
                className="lg:h-[480px] lg:w-[450px] xl:w-[600px] object-cover"
              />
              <div className="absolute top-4 right-4 bg-white p-4 rounded-xl shadow">
                <div className="text-center text-primary text-2xl font-bold">
                  50+
                </div>
                <p className="text-xs text-gray-600">Happy Clients</p>
              </div>
            </div>

            <div className="bg-primary text-white p-6 rounded-xl shadow relative">
              <div className="flex items-center gap-4 mb-4">
                <div className="bg-white/20 p-3 rounded-xl">
                  <FaDownload className="text-white text-lg" />
                </div>
                <div>
                  <h3 className="text-xl font-bold">People Process Teck</h3>
                  <p className="text-sm text-red-100">Brochures</p>
                </div>
              </div>
              <div className="flex gap-8">
                <button className="bg-white text-primary px-4 py-2 rounded-lg font-semibold flex items-center gap-2">
                  <a href={brochure} download="brochure">
                    E-Brochures
                  </a>
                  <FaDownload className="text-sm" />
                </button>
                <button className="bg-white text-primary px-4 py-2 rounded-lg font-semibold flex items-center gap-2">
                  <a href={IndigisBrochure} download="brochure">
                    Indigis-Brochure
                  </a>
                  <FaDownload className="text-sm" />
                </button>
              </div>
            </div>
          </div>

          {/* Right Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <h2 className="text-4xl font-bold text-gray-900 leading-tight">
                Our Proven Track Record: Delivering Excellence from Government to Enterprise 
              </h2>
              <p className="text-gray-600 text-justify">
               From incorporation, we at People Process Teck have significantly expanded our 
               footprint, earning the trust of major industry leaders, public sector behemoths,
                and strategic government institutions across India. In our technology and geospatial 
                domain, our high-level capabilities are highlighted by our elite status as a
                 DRDO ToT (Transfer of Technology) Authorized Partner for INDIGIS Enterprise 
                 Technology, alongside our impactful engagements with the Odisha Space Applications 
                 Centre (ORSAC). We have helped source and deploy strategic talent for major industrial,
                  infrastructure, Information Technology and hospitality companies.  Our comprehensive 
                  compliance assurance services to renewable power conglomerates and manufacturing plants 
                  has driven operational and strategic excellence. By consistently delivering targeted 
                  solutions to industry giants UltraTech and Wheels India, we have proven our versatile
                   capability to empower diverse sectors nationwide. 
              </p>
            </div>

            <div className="grid grid-cols-3 gap-4">
              <div className="bg-white rounded-xl p-4 text-cenx`xter shadow border">
                <div className="text-primary text-xl mb-2">
                  <FaUsers />
                </div>
                <div className="text-xl font-bold text-gray-900">50+</div>
                <p className="text-sm text-gray-600">Clients Served</p>
              </div>
              <div className="bg-white rounded-xl p-4 text-center shadow border">
                <div className="text-primary text-xl mb-2">
                  <FaUsers />
                </div>
                <div className="text-xl font-bold text-gray-900">10+</div>
                <p className="text-sm text-gray-600">Industries</p>
              </div>
              <div className="bg-white rounded-xl p-4 text-center shadow border">
                <div className="text-primary text-xl mb-2">
                  <FaUsers />
                </div>
                <div className="text-xl font-bold text-gray-900">1000+</div>
                <p className="text-sm text-gray-600">Employees Employed</p>
              </div>
            </div>

           
          </div>
        </div>
      </section>

      <section ref={ref3} className="bg-gray-100 py-10">
        <div className="grid lg:grid-cols-2 xl:grid-cols-2 xl:px-20 p-3 lg:gap-10">
          <div className="w-[100%] xl:w-[90%]  lg:w-[100%] sm:w-[100%] md:w-[100%] flex justify-center items-center">
            <img
              src={business_growth}
              alt=""
              className="xl:h-[100%] lg:h-[100%] "
            />
          </div>
          <div className="grid xl:grid-cols-1 lg:grid-cols-1 justify-end items-start gap-4">
            <h2 className="text-4xl font-bold text-gray-900 leading-tight">
              Inspiring {" "}
              <span className="text-primary">Startups</span>{" "}
            </h2>
            <p className="text-xl xl:text-base lg:text-lg sm:text-center text-center">
              Our comprehensive Outsourced HR Operations empower start-ups to
              navigate their HR needs efficiently. From registration formalities
              to organization design and policy automation, we provide the
              support you need to build a strong foundation for growth.
            </p>
            <div className="flex flex-col justify-start items-start gap-5">
              <div className="flex justify-center items-center gap-4">
                <img
                  src={register_icon}
                  alt=""
                  className="w-[40px] xl:w-[80px] lg:w-[50px]"
                />
                <h1 className="xl:text-xl lg:text-sm ">
                  Registration formalities, both statutory and non-statutory
                </h1>
              </div>
              <div className=" flex justify-center items-center gap-4">
                <img
                  src={time_icon}
                  alt=""
                  className=" w-[40px] xl:w-[80px] lg:w-[50px]"
                />
                <h1 className="xl:text-xl lg:text-sm  ">
                  Obtaining statutory clearances, including environmental
                  approvals
                </h1>
              </div>
              <div className=" flex justify-center items-center gap-4 ">
                <img
                  src={bulb_icon}
                  alt=""
                  className="w-[40px] xl:w-[80px] lg:w-[50px]"
                />
                <h1 className="xl:text-xl lg:text-sm  ">
                  Organization design and deployment
                </h1>
              </div>
              <div className="flex justify-center items-center gap-4">
                <img
                  src={hiring_icon}
                  alt=""
                  className="w-[40px] xl:w-[80px] lg:w-[50px]"
                />
                <h1 className="xl:text-xl lg:text-sm  ">
                  Hiring, process, policy, and system automation
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div className="px-8 py-10 h-fit bg-gray-100 xl:my-12">
        <h1 className="text-2xl lg:text-4xl xl:text-4xl 2xl:text-4xl text-center font-bold">
          Our Clients
        </h1>

        <Swiper
  modules={[Navigation, Pagination, Autoplay]}
  spaceBetween={isMobile ? 0 : 50}
  breakpoints={{
    360: {
      slidesPerView: 1,
    },
    640: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 3,
    },
  }}
  navigation={false}
  loop={true}
  autoplay={{
    delay: 1000,
    disableOnInteraction: false,
  }}
  className="mt-12"
>
  <SwiperSlide className="flex justify-center items-center h-[3.5rem] p-1 bg-white rounded-md">
    <img
      src={clientOne}
      alt=""
      className="max-w-[55%] max-h-full object-contain mx-auto"
    />
  </SwiperSlide>
  <SwiperSlide className="flex justify-center items-center h-[3.5rem] p-1 bg-white rounded-md">
    <img
      src={clientTwo}
      alt=""
      className="max-w-[55%] max-h-full object-contain mx-auto"
    />
  </SwiperSlide>
  <SwiperSlide className="flex justify-center items-center h-[3.5rem] p-1 bg-white rounded-md">
    <img
      src={clientThree}
      alt=""
      className="max-w-[55%] max-h-full object-contain mx-auto"
    />
  </SwiperSlide>
  <SwiperSlide className="flex justify-center items-center h-[3.5rem] p-1 bg-white rounded-md">
    <img
      src={clientFour}
      alt=""
      className="max-w-[55%] max-h-full object-contain mx-auto"
    />
  </SwiperSlide>
  <SwiperSlide className="flex justify-center items-center h-[3.5rem] p-1 bg-white rounded-md">
    <img
      src={clientFive}
      alt=""
      className="max-w-[55%] max-h-full object-contain mx-auto"
    />
  </SwiperSlide>
  <SwiperSlide className="flex justify-center items-center h-[3.5rem] p-1 bg-white rounded-md">
    <img
      src={clientSix}
      alt=""
      className="max-w-[55%] max-h-full object-contain mx-auto"
    />
  </SwiperSlide>
  <SwiperSlide className="flex justify-center items-center h-[3.5rem] p-1 bg-white rounded-md">
    <img
      src={clientSeven}
      alt=""
      className="max-w-[55%] max-h-full object-contain mx-auto"
    />
  </SwiperSlide>
  <SwiperSlide className="flex justify-center items-center h-[3.5rem] p-1 bg-white rounded-md">
    <img
      src={clientEigth}
      alt=""
      className="max-w-[55%] max-h-full object-contain mx-auto"
    />
  </SwiperSlide>
  <SwiperSlide className="flex justify-center items-center h-[3.5rem] p-1 bg-white rounded-md">
    <img
      src={clientNine}
      alt=""
      className="max-w-[55%] max-h-full object-contain mx-auto"
    />
  </SwiperSlide>
  <SwiperSlide className="flex justify-center items-center h-[3.5rem] p-1 bg-white rounded-md">
    <img
      src={clientTen}
      alt=""
      className="max-w-[55%] max-h-full object-contain mx-auto"
    />
  </SwiperSlide>
  <SwiperSlide className="flex justify-center items-center h-[3.5rem] p-1 bg-white rounded-md">
    <img
      src={clientEleven}
      alt=""
      className="max-w-[55%] max-h-full object-contain mx-auto"
    />
  </SwiperSlide>
  <SwiperSlide className="flex justify-center items-center h-[3.5rem] p-1 bg-white rounded-md">
    <img
      src={clientTwelve}
      alt=""
      className="max-w-[55%] max-h-full object-contain mx-auto"
    />
  </SwiperSlide>
  <SwiperSlide className="flex justify-center items-center h-[3.5rem] p-1 bg-white rounded-md">
    <img
      src={clientThirteen}
      alt=""
      className="max-w-[55%] max-h-full object-contain mx-auto"
    />
  </SwiperSlide>
  <SwiperSlide className="flex justify-center items-center h-[3.5rem] p-1 bg-white rounded-md">
    <img
      src={clientFourteen}
      alt=""
      className="max-w-[55%] max-h-full object-contain mx-auto"
    />
  </SwiperSlide>
  <SwiperSlide className="flex justify-center items-center h-[3.5rem] p-1 bg-white rounded-md">
    <img
      src={clientFifthteen}
      alt=""
      className="max-w-[55%] max-h-full object-contain mx-auto"
    />
  </SwiperSlide>
  <SwiperSlide className="flex justify-center items-center h-[3.5rem] p-1 bg-white rounded-md">
    <img
      src={clientSixteen}
      alt=""
      className="max-w-[55%] max-h-full object-contain mx-auto"
    />
  </SwiperSlide>
  <SwiperSlide className="flex justify-center items-center h-[3.5rem] p-1 bg-white rounded-md">
    <img
      src={clientSeveteen}
      alt=""
      className="max-w-[55%] max-h-full object-contain mx-auto"
    />
  </SwiperSlide>
  <SwiperSlide className="flex justify-center items-center h-[3.5rem] p-1 bg-white rounded-md">
    <img
      src={clientEighteen}
      alt=""
      className="max-w-[55%] max-h-full object-contain mx-auto"
    />
  </SwiperSlide>
  <SwiperSlide className="flex justify-center items-center h-[3.5rem] p-1 bg-white rounded-md">
    <img
      src={clientNineteen}
      alt=""
      className="max-w-[55%] max-h-full object-contain mx-auto"
    />
  </SwiperSlide>
  <SwiperSlide className="flex justify-center items-center h-[3.5rem] p-1 bg-white rounded-md">
    <img
      src={clientTwenty}
      alt=""
      className="max-w-[55%] max-h-full object-contain mx-auto"
    />
  </SwiperSlide>
  <SwiperSlide className="flex justify-center items-center h-[3.5rem] p-1 bg-white rounded-md">
    <img
      src={clientTwentyOne}
      alt=""
      className="max-w-[55%] max-h-full object-contain mx-auto"
    />
  </SwiperSlide>
  <SwiperSlide className="flex justify-center items-center h-[3.5rem] p-1 bg-white rounded-md">
    <img
      src={clientTwentyTwo}
      alt=""
      className="max-w-[55%] max-h-full object-contain mx-auto"
    />
  </SwiperSlide>
  <SwiperSlide className="flex justify-center items-center h-[3.5rem] p-1 bg-white rounded-md">
    <img
      src={clientTwentyThree}
      alt=""
      className="max-w-[55%] max-h-full object-contain mx-auto"
    />
  </SwiperSlide>
  <SwiperSlide className="flex justify-center items-center h-[3.5rem] p-1 bg-white rounded-md">
    <img
      src={clientTwentyFour}
      alt=""
      className="max-w-[55%] max-h-full object-contain mx-auto"
    />
  </SwiperSlide>
  <SwiperSlide className="flex justify-center items-center h-[3.5rem] p-1 bg-white rounded-md">
    <img
      src={clientTwentyFive}
      alt=""
      className="max-w-[55%] max-h-full object-contain mx-auto"
    />
  </SwiperSlide>
</Swiper>
      </div>
      
      </section>

      <h1 className="lg:mt-16 lg:text-5xl 2xl:text-4xl text-center text-4xl font-bold text-gray-900 leading-tight">
        Case <span className="text-primary">Studies</span>{" "}
      </h1>
      <p className="text-center text-lg">Some of our work across industries</p>
      <div className="my-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-1 gap-4 h-full px-20">
          <Link
            to="/orsac-project"
            className="flip-card block shadow-card rounded-lg h-72 w-full"
          >
            <div className="flip-card-inner w-full rounded-lg">
              {/* Front Side */}
              <div className="flip-card-front flex flex-col justify-between h-72">
                <img
                  className="w-full h-full object-cover rounded-xl"
                  src={case_studies1}
                  alt="ORSAC Project"
                />
                <div className="absolute top-32 bg-white bg-opacity-80 w-full h-fit flex items-center justify-center align-items-center align">
                  <h1 className=" font-extrabold text-2xl text-primary text-center">
                    GIS & Remote Sensing Applications{" "}
                  </h1>
                </div>
              </div>

              {/* Back Side */}
              <div className="flip-card-back w-fit h-fit bg-blue-200 flex flex-col">
                <p className="text-center text-sm font-medium px-3">
                  At People Process Teck, we specialize in GIS and Remote
                  Sensing technologies to develop advanced applications for
                  industries like renewable energy, logistics, infrastructure,
                  and environmental management. Our skilled manpower, deployed
                  at Odisha Satellite Applications Center (ORSAC), is actively
                  engaged in building cutting-edge geospatial solutions to
                  support data-driven decision-making.
                </p>
                <a href="/orsac-project" target="_blank" className="mt-5">
                  <button className="text-lg text-gray-700 hover:text-white hover:bg-primary px-4 py-2 rounded-md transition-all duration-300">
                    Learn More →
                  </button>
                </a>
              </div>
            </div>
          </Link>

          <Link
            to="/redefining-productivity-incentives"
            className="flip-card block shadow-card rounded-lg h-72 w-full"
          >
            <div className="flip-card-inner w-full rounded-lg">
              {/* Front Side */}
              <div className="flip-card-front flex flex-col justify-between h-72">
                <img
                  className="w-full h-full object-cover rounded-xl"
                  src={case_studies3}
                  alt="ORSAC Project"
                />
                <div className="absolute top-32 bg-white bg-opacity-80 w-full h-fit flex items-center justify-center align-items-center align">
                  <h1 className=" font-extrabold text-2xl text-primary text-center">
                    Redefining Productivity Incentives
                  </h1>
                </div>
              </div>

              {/* Back Side */}
              <div className="flip-card-back w-fit h-fit bg-blue-200 flex flex-col">
                <p className="text-center text-sm font-medium px-3">
                  We partnered with a leading organization to overhaul their
                  traditional incentive model. By aligning rewards with
                  performance metrics and team outcomes, we boosted employee
                  engagement and output. Our strategic approach led to
                  measurable improvements in efficiency and job satisfaction.
                  This case study showcases how data-driven incentives can
                  transform workplace motivation.
                </p>
                <a href="/orsac-project" target="_blank" className="mt-5">
                  <button className="text-lg text-gray-700 hover:text-white hover:bg-primary px-4 py-2 rounded-md transition-all duration-300">
                    Learn More →
                  </button>
                </a>
              </div>
            </div>
          </Link>

          <Link
            to="/strategic-overhaul"
            className="flip-card block shadow-card rounded-lg h-72 w-full"
          >
            <div className="flip-card-inner w-full rounded-lg">
              {/* Front Side */}
              <div className="flip-card-front flex flex-col justify-between h-72">
                <img
                  className="w-full h-full object-cover rounded-xl"
                  src={case_studies2}
                  alt="ORSAC Project"
                />
                <div className="absolute top-32 bg-white bg-opacity-80 w-full h-fit flex items-center justify-center align-items-center align">
                  <h1 className=" font-extrabold text-2xl text-primary text-center">
                    Strategic Overhaul
                  </h1>
                </div>
              </div>

              {/* Back Side */}
              <div className="flip-card-back w-fit h-fit bg-blue-200 flex flex-col">
                <p className="text-center text-sm font-medium px-3">
                  We partnered with the client to rethink and restructure their
                  core business strategy for long-term success. Through
                  data-driven insights, leadership alignment, and focused
                  execution plans, we eliminated inefficiencies and realigned
                  priorities. This overhaul enhanced operational agility,
                  improved resource utilization, and positioned the company for
                  sustainable growth. Our approach enabled a seamless shift from
                  reactive to proactive strategy execution.
                </p>
                <a href="/orsac-project" target="_blank" className="mt-5">
                  <button className="text-lg text-gray-700 hover:text-white hover:bg-primary px-4 py-2 rounded-md transition-all duration-300">
                    Learn More →
                  </button>
                </a>
              </div>
            </div>
          </Link>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Home;
